import { WarningOutlined,DownloadOutlined } from "@ant-design/icons";
import constants from "@app/constants";
import { Button, Input, Modal, Row, Col, Typography } from "antd";
import type { InputRef } from 'antd';
import React, { useEffect, useRef,useState } from "react";
import { useHistory, useLocation } from "react-router-dom";
import styles from "./index.module.less";
import {verifySecureLink,requestOtp,verifyOtp } from '@app/api/fileAreaService';
import { error } from "console";
import moment from 'moment';

const { Title, Text, Link } = Typography;


export default () => {
    const history = useHistory();
    const [visible, setVisible] = useState(false);
    const [invalidLink, setInvalidLink] = useState(false);
    const [email, setEmail] = useState("");
    const [otpRequested, setOtpRequested] = useState(false);
    const [otp, setOtp] = useState(["", "", "", "","", ""]);
    const otpRefs = useRef<Array<InputRef | null>>([]);
    const [otpSentEmail, setOtpSentEmail] = useState("");
    const [otpError, setOtpError] = useState("");
    const [invalidEmailError, setInvalidEmailError] = useState("");
    const [otpSuccessMessage, setOtpSuccessMessage] = useState("");
    const [fileDownloadLinks, setFileDownloadLinks] = useState([]);
    const [expiryDate, setExpiryDate] = useState<string | null>(null);

    const isValidEmail = (email: string) => {
      const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      return re.test(email);
    };

    // Inside your component:
const location = useLocation();

const getSecureLinkParams = () => {
  const pathMatch = location.pathname.match(/\/secure-link\/([^/?]+)/);
  const secureLinkReference = pathMatch ? pathMatch[1] : "";

  const params = new URLSearchParams(location.search);
  const accessToken = params.get("access_token") || "";

  return { secureLinkReference, accessToken };
};

useEffect(()=>{
  getSecureLinkParams()
  
  verifySecureLink(accessToken, secureLinkReference)
  .then((response) => {
    if (!response?.data?.isValid) {
      setInvalidLink(true);
      setVisible(true);
    }else{
      setInvalidLink(false);
      setVisible(true);
      setExpiryDate(response.data?.secureLink?.expiryDate || null);     
    }
  })
  .catch((err) => {
    setInvalidLink(true);
    setVisible(true);
  });

},[])

const { secureLinkReference, accessToken } = getSecureLinkParams();
    
    const handleEmailChange = (e: React.ChangeEvent<HTMLInputElement>) => setEmail(e.target.value);

    const handleOtpChange = (value: string, idx: number) => {
        const newOtp = [...otp];
        newOtp[idx] = value.replace(/[^0-9]/g, "").slice(0, 1);
        setOtp(newOtp);
    
        // Move to next input if value is entered and not last box
        if (value && idx < otp.length - 1) {
          otpRefs.current[idx + 1]?.focus();
        }
        // Move to previous input if value is cleared and not first box
        if (!value && idx > 0) {
          otpRefs.current[idx - 1]?.focus();
        }
      };

    const handleRequestOtp = () => {
      setOtpSentEmail(email);
      setOtpRequested(true)   
      requestOtp(accessToken, secureLinkReference,email)
      .then((response) => {
        if(!response?.data?.isSuccessful) {
          setInvalidEmailError("This secure link is no longer active or not authorized for the provided recipient");
          setOtpRequested(false);
        } else {
          setOtpSuccessMessage("OTP sent successfully to " + email);
          setInvalidEmailError("");
          setOtp(["", "", "", "","", ""]); // Reset OTP input fields
          otpRefs.current[0]?.focus(); // Focus the first input field
        }
      })
      .catch((err) => {
        setOtpSuccessMessage("");
      });
    };

      const handleVerifyOtp = () => {
  const otpString = otp.join("");
  verifyOtp(accessToken, secureLinkReference, otpSentEmail, otpString)
    .then((response) => {
      
      setOtpSuccessMessage("");
      if(!response?.data?.isSuccessful) {
        setOtpError(response.data?.errorMessage);
        return;
      }
      setOtpError(""); 
      setFileDownloadLinks(response.data.fileDownloadLinks || []);
      
          
    })
    .catch((err) => {
      setOtpError("An error occurred while verifying the OTP. Please try again.");
      console.error("OTP verification failed:", err);
    });
};

    const handleResendOtp = () =>{ 
      setOtp(["", "", "", "","", ""])
    
      setOtpSentEmail(email);
        
      requestOtp(accessToken, secureLinkReference,email)
      .then((response) => {
        //add OTP success message
      })
      .catch((err) => {
       
      });
    };

    return (
      <Modal
        visible={visible}
        title={fileDownloadLinks.length > 0 ?'Download File(s)':'Secure Access'}
        maskClosable={false}
        destroyOnClose={true}
        className="yjCommonModalSmall"
        footer={null}
        closable={false}
        centered
      >
 {invalidLink ? (
    <div style={{ textAlign: "center", color: "red", padding: 32 }}>
      <WarningOutlined style={{ fontSize: 32, marginBottom: 16 }} />
      <div style={{ marginTop: 16, fontWeight: 500 }}>
      This secure link is no longer active or not authorized for the provided recipient
      </div>
    </div>
  ) : fileDownloadLinks.length > 0 ? (
    <div style={{ textAlign: "center", padding: 32 }}>
      <Title level={5} style={{ color: "#1890ff" }}><DownloadOutlined /><span style={{paddingRight:10}}/>Click the link(s) to download the file(s) {expiryDate && (
  <> (Expiration Date: {moment.utc(expiryDate).format('MM/DD/YYYY')})</>
)}
  </Title>
      {fileDownloadLinks.map((file: any, idx: number) => (
        <div key={idx} style={{ margin: "16px 0" }}>
          <a href={file.uri} target="_blank" rel="noopener noreferrer">
            {file.displayName}
          </a>
        </div>
      ))}
    </div>
  ) : (
    <>
      <div style={{ marginBottom: 16 }}>
          <Text>Email Address </Text>
        </div>
        
          <Row gutter={8} style={{ marginBottom: 16 }}>
            <Col flex="auto">
                <Input
                placeholder="Enter email address"
                value={email}
                onChange={handleEmailChange}
                disabled={otpRequested}
                />
            </Col>
            <Col>
                <Button
                type="primary"
                onClick={handleRequestOtp}
                disabled={!email || !isValidEmail(email)}
                >
                Request OTP
                </Button>
            </Col>
           </Row>
           {invalidEmailError && (
              <div style={{ color: "red", textAlign: "center", marginTop: 8 }}>
                {invalidEmailError}
              </div>
            )}
           {otpSuccessMessage && (
              <div style={{ color: "green", textAlign: "center", marginBottom: 8 }}>
                {otpSuccessMessage}
              </div>
            )}
            <div style={{ margin: "24px 0 8px 0" }}>
              <Text>Please enter the one-time passcode (OTP) sent to your email address to access the files</Text>
            </div>
            <Row gutter={8} justify="center">
              {otp.map((digit, idx) => (
                <Col key={idx}>
                  <Input
                  ref={el => (otpRefs.current[idx] = el)}
                    style={{ width: 40, textAlign: "center" }}
                    maxLength={1}
                    value={digit}
                    onChange={e => handleOtpChange(e.target.value, idx)}
                  />
                </Col>
              ))}
            </Row>
            {otpError && (
              <div style={{ color: "red", textAlign: "center", marginTop: 8 }}>
                {otpError}
              </div>
            )}
            <Button
              type="primary"
              block
              style={{ marginTop: 16 }}
              disabled={otp.some(d => d === "")}
              onClick={handleVerifyOtp}
            >
              Verify
            </Button>
            <div style={{ marginTop: 16, textAlign: "center" }}>
              <Link onClick={handleResendOtp}>Resend OTP</Link>
            </div>
    </>
  )}

        

      </Modal>
    );
  };